// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState, Fragment } from "react";
import { Upload, Modal } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { getBase64 } from "src/utils/blobs";
import { PhotoStatus } from "src/containers/accountManagement/facilityPhotos/api";

const MAX_FACILITY_PHOTOS = 30;

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PhotosUploader(props: any) {
  const {
    fileName = "new Photos",
    isLoading = true,
    fileList = [],
    setFileList,
    onPhotosChanged,
    filesToDelete,
    setFilesToDelete,
    readOnly = false,
  } = props;
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const handleCancel = () => {
    setPreviewVisible(false);
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'file' implicitly has an 'any' type.
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf("/") + 1));
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'onChange' implicitly has an 'any' type.
  const handleChange = async (onChange) => {
    setIsUploadingImage(true);
    if (onChange?.file?.status === PhotoStatus.REMOVED) {
      onChange.fileList = onChange.fileList.filter(
        // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'imageItem' implicitly has an 'any' type.
        (imageItem) => imageItem.index !== onChange.file.index
      );
      if (onChange?.file?.fileStorageFileKey && onChange.file?.fileStorageRootFolder) {
        setFilesToDelete([
          ...filesToDelete,
          {
            fileStorageFileKey: onChange?.file?.fileStorageFileKey,
            fileStorageRootFolder: onChange.file?.fileStorageRootFolder,
          },
        ]);
      }
    } else {
      if (onChange.file.originFileObj) {
        onChange.file.name = `${fileName}-${onChange.fileList.length}`;
        const lastIndex = onChange.fileList.length - 1;
        if (lastIndex > -1) {
          onChange.fileList[lastIndex].name = `${fileName}-${onChange.fileList.length}`;
        }
      }
    }

    onPhotosChanged(onChange.fileList);
    setFileList(onChange.fileList);
    setIsUploadingImage(false);
  };

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'onSuccess' implicitly has an 'any' type.
  const appendFile = ({ onSuccess, file, onProgress }) => {
    const fmData = new FormData();
    fmData.append("image", file);
    onProgress({ percent: 50 });
    setTimeout(() => {
      onSuccess({
        result: {},
        file,
      });
      onProgress({ percent: 100 });
    }, 500);
  };

  const uiLoading = (
    <Fragment>
      <LoadingOutlined />
      <div style={{ marginTop: 8 }}>Loading...</div>
    </Fragment>
  );
  const uploadButton = (
    <div>
      {isLoading || isUploadingImage ? (
        uiLoading
      ) : (
        <Fragment>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </Fragment>
      )}
    </div>
  );
  return (
    <Fragment>
      <Upload
        disabled={readOnly || isLoading}
        /* @ts-expect-error FIXME this wrong type */
        customRequest={appendFile}
        accept="image/*"
        listType="picture-card"
        fileList={fileList}
        maxCount={MAX_FACILITY_PHOTOS}
        onPreview={handlePreview}
        onChange={handleChange}
      >
        {fileList.length < MAX_FACILITY_PHOTOS || isUploadingImage || isLoading
          ? uploadButton
          : null}
      </Upload>
      <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="photos" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </Fragment>
  );
}
